import { FormikProps } from 'formik';
import { Card } from '@/components/ui/card';
import { QuestionFormValues } from '@/utils/forms/questionTransformers';
import { OptionTextFields } from './OptionTextFields';
import { OptionImageFields } from './OptionImageFields';
import { OptionCorrectToggle } from './OptionCorrectToggle';

interface OptionCardProps {
  index: number;
  formik: FormikProps<QuestionFormValues>;
  selectedTeams?: string[];
  translateField: (
    sourceKey: string,
    sourceValue: string,
    targetKey: string,
    setFieldValue: any
  ) => void;
  isFieldTranslating: (key: string) => boolean;
  isEditable: boolean;
}

export function OptionCard({
  index,
  formik,
  selectedTeams = [],
  translateField,
  isFieldTranslating,
  isEditable,
}: OptionCardProps) {
  const { errors, touched, values, setFieldValue } = formik;
  const option = values.options[index];

  return (
    <Card className="p-4">
      <div className="space-y-4">
        <OptionTextFields
          index={index}
          optionTextEn={option.option_text_en || ''}
          optionTextFr={option.option_text_fr || ''}
          errors={errors.options?.[index] as any}
          touched={touched.options?.[index]}
          translateField={translateField}
          isFieldTranslating={isFieldTranslating}
          setFieldValue={setFieldValue}
          isEditable={isEditable}
        />

        <OptionImageFields
          index={index}
          optionImageEn={option.option_image_en || ''}
          optionImageFr={option.option_image_fr || ''}
          selectedTeams={selectedTeams}
          setFieldValue={setFieldValue}
          isEditable={isEditable}
        />

        <OptionCorrectToggle
          index={index}
          isCorrect={option.is_correct}
          setFieldValue={setFieldValue}
          isEditable={isEditable}
        />
      </div>
    </Card>
  );
}
